/* bs-product-datasheet — acordeón de 3 ítems (Descripción / Especificaciones / Envío y
   devoluciones), solo UNO abierto a la vez. Header = <button aria-expanded>, panel animado
   por height: mismo patrón que bs-faq-help.js/bs-contact-form.js (scrollHeight + doble rAF +
   transitionend), adaptado a button/div en vez de details/summary porque necesitamos forzar
   el estado "solo uno abierto" (details no lo soporta de forma nativa). */

(function () {
  'use strict';

  var OPEN_CLASS = 'bs-product-datasheet__item--open';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animateOpen(item, trigger, panel) {
    panel.dataset.animating = 'true';
    item.classList.add(OPEN_CLASS);
    trigger.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('inert'); // a11y: panel abierto vuelve al árbol de foco/AT

    if (reduceMotion) {
      panel.style.height = '';
      panel.dataset.animating = '';
      return;
    }

    var target = panel.scrollHeight;
    panel.style.height = '0px';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.style.height = target + 'px';
      });
    });

    function onEnd(e) {
      if (e.target !== panel || e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      panel.style.height = '';
      panel.dataset.animating = '';
    }
    panel.addEventListener('transitionend', onEnd);
  }

  function animateClose(item, trigger, panel) {
    panel.dataset.animating = 'true';
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('inert', ''); // a11y: panel cerrado fuera del árbol de foco/AT (inmediato)

    if (reduceMotion) {
      item.classList.remove(OPEN_CLASS);
      panel.style.height = '';
      panel.dataset.animating = '';
      return;
    }

    var start = panel.scrollHeight;
    panel.style.height = start + 'px';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });
    });

    function onEnd(e) {
      if (e.target !== panel || e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      item.classList.remove(OPEN_CLASS);
      panel.style.height = '';
      panel.dataset.animating = '';
    }
    panel.addEventListener('transitionend', onEnd);
  }

  function initSection(section) {
    if (section.dataset.bsProductDatasheetInit) return;
    section.dataset.bsProductDatasheetInit = 'true';

    var list = section.querySelector('.bs-product-datasheet__list');
    if (!list) return;
    var items = list.querySelectorAll('.bs-product-datasheet__item');

    list.addEventListener('click', function (event) {
      var trigger = event.target.closest('.bs-product-datasheet__trigger');
      if (!trigger || !list.contains(trigger)) return;

      var item = trigger.closest('.bs-product-datasheet__item');
      var panel = item && item.querySelector('.bs-product-datasheet__panel');
      if (!item || !panel || panel.dataset.animating === 'true') return;

      var isOpen = item.classList.contains(OPEN_CLASS);

      if (isOpen) {
        animateClose(item, trigger, panel);
        return;
      }

      /* Solo un ítem abierto a la vez: cierra los demás antes de abrir el actual. */
      items.forEach(function (other) {
        if (other === item || !other.classList.contains(OPEN_CLASS)) return;
        var otherTrigger = other.querySelector('.bs-product-datasheet__trigger');
        var otherPanel = other.querySelector('.bs-product-datasheet__panel');
        if (otherTrigger && otherPanel && otherPanel.dataset.animating !== 'true') {
          animateClose(other, otherTrigger, otherPanel);
        }
      });

      animateOpen(item, trigger, panel);
    });
  }

  function init(root) {
    var sections = (root || document).querySelectorAll('.bs-product-datasheet');
    sections.forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bs-product-datasheet');
    if (section) init(event.target);
  });
})();
